import { VIcon } from 'vuetify/lib/components/VIcon';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      def: Ripple,
      name: "ripple",
      rawName: "v-ripple",
      value: _vm.isCopySupported,
      expression: "isCopySupported"
    }],
    class: {
      'copy-clipboard-element': true,
      small: _vm.small,
      'full-width': _vm.fullWidth,
      'no-copy': !_vm.isCopySupported
    },
    attrs: {
      "title": _vm.isTruncated && _vm.internalContent
    },
    on: {
      "click": function ($event) {
        _vm.isCopySupported ? _vm.copyToClipboard($event, _vm.internalContent) : undefined;
      }
    }
  }, [_c('pre', {
    ref: "text"
  }, [_vm._v(_vm._s(_vm.label || _vm.internalContent))]), _vm.isCopySupported ? _c(VIcon, {
    attrs: {
      "small": !_vm.small,
      "x-small": _vm.small
    }
  }, [_vm._v("fal fa-copy")]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };